<template>
  <div class="category-deposit-container">
    <h1 class="main-title">类目保证金标准</h1>

    <table class="deposit-table">
      <colgroup>
        <col class="col-category" />
        <col class="col-deposit" />
      </colgroup>
      <thead>
        <tr>
          <th class="cell-category-header">一级类目</th>
          <th class="cell-deposit-header">
            <div class="deposit-title">类目保证金（元）</div>
            <div class="deposit-tag">
              <span class="icon">💥</span><u class="tag-text">限时</u
              ><span class="icon">💥</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in categoryList" :key="index">
          <td class="cell-category">{{ item.name }}</td>
          <td class="cell-deposit">{{ item.deposit }}</td>
        </tr>
      </tbody>
    </table>

    <div class="note-section">
      <div class="note-title">说明：</div>
      <ol class="note-list">
        <li v-for="(note, index) in noteList" :key="index">
          {{ note }}
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryDeposit",
  data() {
    return {
      categoryList: [
        { name: "手表配饰", deposit: "5000" },
        { name: "个人洗护", deposit: "5000" },
        { name: "医药健康", deposit: "5000" },
        { name: "宠物", deposit: "5000" },
        { name: "母婴", deposit: "5000" },
        { name: "服装鞋靴", deposit: "5000" },
        { name: "家居生活", deposit: "5000" },
        { name: "生鲜", deposit: "5000" },
        { name: "生活服务", deposit: "5000" },
        { name: "运动户外", deposit: "5000" },
        { name: "美容彩妆", deposit: "5000" },
        { name: "数码家电", deposit: "5000" },
        { name: "汽车用品", deposit: "5000" },
        { name: "环球美食", deposit: "5000" },
        { name: "箱包", deposit: "5000" }
      ],
      noteList: [
        "保证金的缴存方式和金额以商家后台页面提示为准。",
        "同一商家，经营多类目时，保证金缴纳采取就高原则，按最高金额缴纳。",
        "部分行业叶子类目基础保证金与对应一级类目基础保证金存在差异，具体以各行业规范中资费标准下的保证金要求为准。"
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.category-deposit-container {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  padding: 40px 60px;
  background-color: #ffffff;
  color: #262626;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  text-align: left;

  .main-title {
    margin: 0 0 28px 0;
    font-size: 26px;
    font-weight: 700;
    color: #1f1f1f;
    line-height: 1.3;
  }

  .deposit-table {
    width: 320px;
    max-width: 100%;
    border-collapse: collapse;
    border: 1px solid #d9d9d9;
    margin-bottom: 24px;

    .col-category {
      width: 132px;
    }

    .col-deposit {
      width: 188px;
    }

    th,
    td {
      border: 1px solid #d9d9d9;
      padding: 10px 14px;
      font-size: 14px;
      line-height: 1.5;
      color: #262626;
    }

    th {
      font-weight: 500;
      background-color: #ffffff;
    }

    .cell-category-header {
      text-align: left;
      vertical-align: middle;
    }

    .cell-deposit-header {
      text-align: center;
      vertical-align: middle;

      .deposit-title {
        color: #000000;
      }

      .deposit-tag {
        margin-top: 4px;
        color: #df2a3f;
        font-size: 13px;

        .icon {
          display: inline-block;
          margin: 0 2px;
          vertical-align: middle;
        }

        .tag-text {
          font-weight: 500;
          text-decoration: underline;
        }
      }
    }

    .cell-category {
      text-align: left;
    }

    .cell-deposit {
      text-align: center;
      color: #000000;
    }
  }

  .note-section {
    max-width: 680px;

    .note-title {
      font-size: 14px;
      font-weight: 700;
      color: #262626;
      margin-bottom: 8px;
    }

    .note-list {
      margin: 0;
      padding-left: 20px;
      font-size: 14px;
      line-height: 1.8;
      color: #262626;

      li {
        margin-bottom: 4px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .category-deposit-container {
    padding: 24px 16px;

    .main-title {
      font-size: 22px;
      margin-bottom: 20px;
    }

    .deposit-table {
      width: 100%;
    }
  }
}
</style>
